export const hasTextSelectionWithin = (element: Element): boolean => {
  const selection = window.getSelection();

  if (!selection?.toString()) {
    return false;
  }

  return element.contains(selection.anchorNode) || element.contains(selection.focusNode);
};
